enum QUERY_KEYS {
  GET_MOCK_DATA = 'GET_MOCK_DATA',
  AUTOCOMPLETE_SEARCH = 'AUTOCOMPLETE_SEARCH',
  GET_BOOKING_LIST = 'GET_BOOKING_LIST',
  GET_BOOKING_LIST_ALL = 'GET_BOOKING_LIST_ALL',
  GET_BOOKING_DETAIL = 'GET_BOOKING_DETAIL',
  GET_ROOM_MAP = 'GET_ROOM_MAP',
  KEY_ROOM = 'KEY_ROOM',
  GET_ROOM_STATUS = 'GET_ROOM_STATUS',
  GET_AVAIL_ROOM_TYPE = 'GET_AVAIL_ROOM_TYPE',
  GET_CUSTOMERS = 'GET_CUSTOMERS',
  GET_PAYMENTS = 'GET_PAYMENTS',
  GET_COUNTRIES = 'GET_COUNTRIES',
  GET_AREAS = 'GET_AREAS',
  GET_ME = 'GET_ME',
  GET_PERMISSION = 'GET_PERMISSION',
  GET_SERVICES = 'GET_SERVICES',
  GET_CLEANING_CALENDAR = 'GET_CLEANING_CALENDAR',
  GET_COMPANIES = 'GET_COMPANIES',
  GET_SOURCES = 'GET_SOURCES',
  GET_CAMPAIGNS = 'GET_CAMPAIGNS',
  GET_STAYING_GUESTS = 'GET_STAYING_GUESTS',
  GET_CASH_FLOW = 'GET_CASH_FLOW',
  GET_CASH_FLOW_ALL = 'GET_CASH_FLOW_ALL',
  GET_CURRENT_NIGHT_AUDIT = 'GET_CURRENT_NIGHT_AUDIT',
  GET_CUSTOMER_BY_ID = 'GET_CUSTOMER_BY_ID',
  GET_ROOM_AVAILABILITY = 'GET_ROOM_AVAILABILITY',
  GET_ROOM_SUMMARY = 'GET_ROOM_SUMMARY',
  GET_ROOM_LOCK = 'GET_ROOM_LOCK',
  GET_TRANSACTIONS = 'GET_TRANSACTIONS',
  GET_TRANSACTIONS_PAYMENT_V2 = 'GET_TRANSACTIONS_PAYMENT_V2',
  GET_ALL_BOOKING_LINES_BY_BOOKING_ID = 'GET_ALL_BOOKING_LINES_BY_BOOKING_ID',
  GET_RESERVATION_FORECAST = 'GET_RESERVATION_FORECAST',
  GET_TRACKING_LOGS = 'GET_TRACKING_LOGS',
  GET_BREAKFASTS = 'GET_BREAKFASTS',
  GET_HOUSE_STATUS = 'GET_HOUSE_STATUS',
  GET_SUB_HK_ROOM = 'GET_SUB_HK_ROOM',
  GET_HK_ROOM = 'GET_HK_ROOM',
  GET_SUB_HK_STAFF = 'GET_SUB_HK_STAFF',
  GET_LIST_MINIBAR = 'GET_LIST_MINIBAR',
  GET_ALL_BRANCHES = 'GET_ALL_BRANCHES',
  GET_CURRENT_BRANCH = 'GET_CURRENT_BRANCH',
  GET_ALL_NATIONALITY = 'GET_ALL_NATIONALITY',
  GET_BOOKING_TIMELINE = 'GET_BOOKING_TIMELINE',
  GET_ALL_LABELS = 'GET_ALL_LABELS',
  GET_CURRENT_SHIFT_HANDOVER = 'GET_CURRENT_SHIFT_HANDOVER',
  GET_ALL_SHIFT_HANDOVER = 'GET_ALL_SHIFT_HANDOVER',
  GET_LATEST_OCR_CUSTOMER_INFO = 'GET_LATEST_OCR_CUSTOMER_INFO',
  GET_ALL_WAREHOUSE_PRODUCTS = 'GET_ALL_WAREHOUSE_PRODUCTS',
  GET_TRAVEL_AGENCIES = 'GET_TRAVEL_AGENCIES',

  GET_GROUP_BOOKINGS = 'GET_GROUP_BOOKINGS',
  GET_GROUP_BOOKING_DETAIL = 'GET_GROUP_BOOKING_DETAIL',
  GET_GUEST = 'GET_GUEST',
  GET_GUEST_TRANSACTIONS = 'GET_GUEST_TRANSACTIONS',
  GET_GUEST_TRANSACTIONS_DETAIL = 'GET_GUEST_TRANSACTIONS_DETAIL',

  GET_FOC_LIST = 'GET_FOC_LIST',
  GET_FOC_DETAILS = 'GET_FOC_DETAILS',

  GET_CONSOLIDATE_REVENUE = 'GET_CONSOLIDATE_REVENUE',
  GET_CONSOLIDATE_SOURCE_REVENUE = 'GET_CONSOLIDATE_SOURCE_REVENUE',
  GET_CONSOLIDATE_CAMPAIGN_REVENUE = 'GET_CONSOLIDATE_CAMPAIGN_REVENUE',
  GET_TRANSACTIONS_CASH_FLOW_ALL = 'GET_TRANSACTIONS_CASH_FLOW_ALL',
  GET_TRANSACTIONS_CASH_FLOW = 'GET_TRANSACTIONS_CASH_FLOW',

  GET_DETAILED_ANALYSIS_REPORT = 'GET_DETAILED_ANALYSIS_REPORT',
  GET_FOLIO_REVENUE_REPORT = 'GET_FOLIO_REVENUE_REPORT',

  GET_BOOKNIG_DISCOUNT = 'GET_BOOKING_DISCOUNT',
  GET_TRANSACTION_HISTORY_LOGS = 'GET_TRANSACTION_HISTORY_LOGS',

  GET_MINVOICE_PREVIEW = 'GET_MINVOICE_PREVIEW',

  GET_TOURS_DATA = 'GET_TOURS_DATA',
  GET_TOUR_DETAIL = 'GET_TOUR_DETAIL',

  GET_E_INVOICE_STATUS = 'GET_E_INVOICE_STATUS',
  GET_BOOKING_REMINDS = 'GET_BOOKING_REMINDS',
  GET_SERVICES_REPORT = 'GET_SERVICES_REPORT',
  GET_SERVICES_REPORT_NO_PAGINATION = 'GET_SERVICES_REPORT_NO_PAGINATION',
  GET_CUSTOMERS_BOOKINGS = 'GET_CUSTOMERS_BOOKINGS',
  GET_ESIM_CAMPAIGNS = 'GET_ESIM_CAMPAIGNS',
  GET_ESIM_URL = 'GET_ESIM_URL',
  GET_ESIM_CAMPAIGN_DETAILS = 'GET_ESIM_CAMPAIGN_DETAILS'
}

export default QUERY_KEYS;
